import React from 'react';

/**
 * Without this, one thrown render error blanks the entire page — React unmounts
 * the tree and the visitor gets white. A studio site failing to white is worse
 * than a studio site failing to one section.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // No error service is wired up; the console is the only sink there is.
    console.error('Render failed:', error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center px-6 py-20 bg-[#FAF2EB]">
        <div className="artisan-card max-w-md w-full p-8 text-center space-y-4">
          <img
            src="/logo-128.webp"
            alt=""
            aria-hidden="true"
            width="56"
            height="56"
            className="w-14 h-14 rounded-full object-cover mx-auto"
          />
          <h1 className="font-90s font-black text-2xl text-[#4E2C23]">
            This page didn&rsquo;t load
          </h1>
          <p className="text-sm text-[#745147] leading-relaxed">
            Something broke on our side, not yours. Reloading usually clears it.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-1">
            <button
              onClick={() => window.location.reload()}
              className="btn-burnt-peach px-6 py-3 text-xs font-bold uppercase tracking-wider"
            >
              Reload the page
            </button>
            <a
              href="https://wa.me/919747901029"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline-espresso px-6 py-3 text-xs font-bold uppercase tracking-wider"
            >
              Message the studio
            </a>
          </div>
        </div>
      </div>
    );
  }
}
